











































import { Vue, Component, Prop } from 'vue-property-decorator';
import AttendanceModel from '@/models/crm/attendance.model';
import AttendanceSummaryModel from '@/models/crm/attendance-summary.model';
import { AttendanceOriginEnum } from '@/enums/crm/attendance-origin.enum';

interface IDistributionEntry {
  origem: string;
  label: string;
  icon: string;
  count: number;
  pct: number;
}

@Component
export default class AttendanceStatsCard extends Vue {
  @Prop({ default: () => [] }) readonly items!: AttendanceModel[];

  @Prop({ default: null }) readonly summary!: AttendanceSummaryModel | null;

  get totalCount(): number {
    return this.summary ? this.summary.totalCount : this.items.length;
  }

  // Tipado pelo enum de propósito: origem nova sem entrada aqui quebra o build, em vez de cair no
  // fallback e aparecer com o código cru no card.
  get originMeta(): Record<AttendanceOriginEnum, { label: string; icon: string }> {
    return {
      [AttendanceOriginEnum.Order]: {
        label: this.$t('crm.view.attendance.origin.order').toString(),
        icon: 'mdi-cart',
      },
      [AttendanceOriginEnum.Email]: {
        label: this.$t('crm.view.attendance.origin.email').toString(),
        icon: 'mdi-email-outline',
      },
      [AttendanceOriginEnum.Calendar]: {
        label: this.$t('crm.view.attendance.origin.calendar').toString(),
        icon: 'mdi-calendar-month-outline',
      },
      [AttendanceOriginEnum.Process]: {
        label: this.$t('crm.view.attendance.origin.process').toString(),
        icon: 'mdi-sitemap',
      },
      [AttendanceOriginEnum.Conversation]: {
        label: this.$t('crm.view.attendance.origin.conversation').toString(),
        icon: 'mdi-chat',
      },
      [AttendanceOriginEnum.SurveyNPS]: {
        label: this.$t('crm.view.attendance.origin.surveynps').toString(),
        icon: 'mdi-star',
      },
      [AttendanceOriginEnum.Call]: {
        label: this.$t('crm.view.attendance.origin.call').toString(),
        icon: 'mdi-phone',
      },
      [AttendanceOriginEnum.Audio]: {
        label: this.$t('crm.view.attendance.origin.audio').toString(),
        icon: 'mdi-microphone',
      },
      [AttendanceOriginEnum.Insight]: {
        label: this.$t('crm.view.attendance.origin.insight').toString(),
        icon: 'mdi-lightbulb-on-outline',
      },
      [AttendanceOriginEnum.EvoTalks]: {
        label: this.$t('crm.view.attendance.origin.evotalks').toString(),
        icon: 'mdi-forum',
      },
      [AttendanceOriginEnum.Note]: {
        label: this.$t('crm.view.attendance.origin.note').toString(),
        icon: 'mdi-note-text-outline',
      },
    };
  }

  get totalValue(): number {
    if (this.summary) return this.summary.totalValue;
    return this.items.reduce((sum, item) => sum + (item.valor || 0), 0);
  }

  get distribution(): IDistributionEntry[] {
    const counts: Record<string, number> = this.summary
      ? this.summary.countByOrigin
      : this.items.reduce((acc, item) => {
        const key = item.origem || 'OUTRO';
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {} as Record<string, number>);

    const total = this.totalCount || 1;
    // O insight fica fora da distribuição: não é evento de contato, mesma razão pela qual sai dos
    // totais no backend. O contador do painel de filtros vem do countByOrigin, que não é filtrado.
    return Object.entries(counts)
      .filter(([origem]) => origem !== AttendanceOriginEnum.Insight)
      .sort((a, b) => b[1] - a[1])
      .map(([origem, count]) => {
        const meta = this.originMeta[origem] || { label: origem, icon: 'mdi-circle-small' };
        return {
          origem,
          label: meta.label,
          icon: meta.icon,
          count,
          pct: Math.round((count / total) * 100),
        };
      });
  }
}
